module.exports = __webpack_public_path__ + "img/InviteFriends.100a3ad1.png";